<template>
    <div class="my-1 d-flex flex-direction-row">
        <SvgIcon
            :title="name"
            :alt="name"
            :name="icon"
            :isBlack="true"
            :width="14"
            :height="14"
        />
         <span class="ml-1">{{ value }}</span>
         <span class="ml-1">{{ metric }}</span>
    </div>
</template>

<script>
    import SvgIcon from "../shared/SvgIcon";

    export default {
        name: "MapPopupIcon",
        components: {
            SvgIcon
        },
        props: {
            name: String,
            icon: String,
            value: [Number, String],
            metric: String
        }
    }
</script>
